import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CTABand } from "@/components/CTABand";

// Wrapper for all content pages (not the cinematic homepage).
export function Layout({ children, cta = true, ctaProps }) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-warm flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      {cta && <CTABand {...ctaProps} />}
      <Footer />
    </div>
  );
}
